import styled from "styled-components";

const SelectWrapper = styled.div`
	width: 100%;
	position: relative;

	.ant-select {
		text-align: left;
		width: 100% !important;
	}

	.ant-select.ant-select-single .ant-select-selector {
		display: flex !important;
		align-items: center !important;
		border-radius: 10px !important;
		background: var(--bt-auth-input-bg, #1f2536) !important;
		border: 1px solid transparent !important;
		height: 48px !important;
		min-height: 48px !important;
		padding: 0 36px 0 10px !important;
		box-shadow: none !important;
		box-sizing: border-box;
	}

	.ant-select.ant-select-single .ant-select-selector .ant-select-selection-search {
		position: absolute !important;
		inset: 0 !important;
		padding: 0 36px 0 10px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select.ant-select-single .ant-select-selector .ant-select-selection-search-input {
		height: 100% !important;
		width: 100% !important;
		line-height: 1.4 !important;
		color: var(--bt-auth-heading-color, #e5f0fe) !important;
		caret-color: var(--bt-auth-heading-color, #e5f0fe);
		padding: 0 !important;
	}

	.ant-select-arrow {
		color: var(--bt-auth-heading-color, #e5f0fe);
		right: 12px;
		top: 50%;
		margin-top: -6px;
	}

	.ant-select.ant-select-single .ant-select-selector .ant-select-selection-item,
	.ant-select.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
		display: flex !important;
		align-items: center !important;
		align-self: center !important;
		color: var(--bt-auth-heading-color, #e5f0fe);
		font-size: 13px !important;
		font-weight: 400;
		letter-spacing: -0.39px;
		height: auto !important;
		max-height: 100% !important;
		line-height: 1.4 !important;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		padding-inline-start: 0 !important;
		padding-inline-end: 0 !important;
		text-align: left;
	}

	.ant-select-selection-placeholder {
		color: var(--bt-auth-input-placeholder, #5b6379) !important;
	}

	.ant-select.phone-addon.ant-select-single .ant-select-selector {
		padding: 0 24px 0 8px !important;
	}

	.ant-select.phone-addon .ant-select-arrow {
		right: 8px;
	}

	.ant-select.phone-addon.ant-select-single .ant-select-selector .ant-select-selection-item,
	.ant-select.phone-addon.ant-select-single .ant-select-selector .ant-select-selection-placeholder {
		font-size: 12px !important;
		letter-spacing: -0.36px;
	}

	.ant-select:not(.ant-select-customize-input) .ant-select-selector {
		border: 1px solid transparent !important;
		border-radius: 10px;
	}

	.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
		.ant-select-selector {
		border: 1px solid var(--bt-auth-primary, #0362d4) !important;
		box-shadow: none !important;
	}

	.ant-select-selection-search input:focus {
		box-shadow: none !important;
	}
`;

const SelectPrefix = styled.div`
	position: absolute;
	z-index: 1;
	left: 15px;
	display: flex;
	top: 14px;
`;

const SelectPlaceholder = styled.div`
	position: absolute;
	z-index: 1;
	left: 40px;
	display: flex;
	top: 12px;
	color: var(--main-secondary-text-color);
	font-size: 12px;
	font-weight: 400;
	letter-spacing: 0.3px;
`;

export { SelectPlaceholder, SelectPrefix, SelectWrapper };
